export default {
    "04-01": {
        year: 1921,
        title: "METRİSTEPE ZAFERİ",
        text: "1921'de II. İnönü Zaferi (Metristepe) kazanıldı. 1979'da İran İslam Cumhuriyeti ilan edildi.",
        questions: [
            {
                text: "Mustafa Kemal Paşa'nın kutlama telgrafı 1 Nisan 1921'de kime çekilmiştir?",
                options: ["Fevzi Çakmak", "Refet Bele", "İsmet İnönü", "Ali Fuat Cebesoy"],
                correct: 2
            },
            {
                text: "Kıbrıs'ta Enosis için kurulan Rum terör örgütü hangisidir?",
                options: ["ASALA", "EOKA", "Megali İdea", "Pontus Rum"],
                correct: 1
            },
            {
                text: "İran İslam Devrimi'nin lideri kimdir?",
                options: ["Hamaney", "Humeyni", "Rafsancani", "Hatemi"],
                correct: 1
            }
        ]
    },
    "04-02": {
        year: 1453,
        title: "İSTANBUL KUŞATMASI",
        text: "1453'te İstanbul kuşatması başladı. 1982'de Falkland Savaşı çıktı.",
        questions: [
            {
                text: "Şahi toplarını döken Macar usta kimdir?",
                options: ["Urban", "Saruca Sekban", "Muslihiddin", "Davud Ağa"],
                correct: 0
            },
            {
                text: "Falkland Savaşı'nda İngiltere Başbakanı (Demir Leydi) kimdir?",
                options: ["Theresa May", "Margaret Thatcher", "II. Elizabeth", "Merkel"],
                correct: 1
            },
            {
                text: "2 Nisan 1918'de kurtulan ve Urartulara başkentlik yapan ilimiz hangisidir?",
                options: ["Kars", "Erzurum", "Van", "Muş"],
                correct: 2
            }
        ]
    },
    "04-03": {
        year: 1930,
        title: "KADINLARA BELEDİYE HAKKI",
        text: "1930'da kadınlara belediye seçim hakkı verildi. 1948'de Marshall Planı imzalandı.",
        questions: [
            {
                text: "Türk kadınına siyasi hakların verilme sırası (BMW) nasıldır?",
                options: ["Milletvekili-Muhtar-Belediye", "Belediye-Muhtar-Milletvekili", "Muhtar-Belediye-Milletvekili", "Belediye-Milletvekili-Muhtar"],
                correct: 1
            },
            {
                text: "Marshall Planı'nın resmi adı nedir?",
                options: ["Truman Doktrini", "AET", "Avrupa Kalkınma Programı (ERP)", "Lend-Lease"],
                correct: 2
            },
            {
                text: "Türkiye'nin ilk Demir Çelik Fabrikası nerede kurulmuştur?",
                options: ["Ereğli", "Karabük", "Kırıkkale", "İskenderun"],
                correct: 1
            }
        ]
    },
    "04-04": {
        year: 1949,
        title: "NATO'NUN KURULUŞU",
        text: "1949'da NATO kuruldu. 1953'te Dumlupınar denizaltısı battı.",
        questions: [
            {
                text: "1949'da NATO'nun kurucu üyeleri arasında hangisi yoktur?",
                options: ["ABD", "İngiltere", "Türkiye", "Fransa"],
                correct: 2
            },
            {
                text: "NATO'nun 'bire yapılan saldırı hepsine yapılmış sayılır' ilkesi kaçıncı maddedir?",
                options: ["1.", "4.", "5.", "10."],
                correct: 2
            },
            {
                text: "MHP'nin kurucu lideri Alparslan Türkeş hangi tarihte vefat etmiştir?",
                options: ["4 Nisan 1997", "Muhsin Yazıcıoğlu", "Osman Bölükbaşı", "Dündar Taşer"],
                correct: 0
            }
        ]
    }
};
